import { t } from '@lingui/macro';

import { usePaletteType } from '../../../utilities/ColorUtilities';
import { PANEL_CATEGORIES, COMPARISON_BREAKDOWN_PANEL_PREVIEW_IMAGE } from '../../page-framework/panel/PanelRegistry';
import {
    agentFilterId,
    businessServiceFilterId,
    siteFilterId,
    testTypeFilterId,
    timeRangeComparisonFilterId,
} from '../../filters';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import Panel from '../../page-framework/panel/PanelDecorator';
import {
    testComparisonDataSource,
    TestComparisonChart,
    useTestComparisonChartConfig,
} from '../../charts/test-comparison-chart/TestComparisonChart';
import {
    VARIANT_BREAKDOWN,
    useTestMetricBreakdownSeries,
} from '../../charts/test-comparison-chart/TestComparisonChartHelper';

import usePanelDataService from '../../../services/PanelDataService';

const title = t`Service Test Comparison Breakdown`;

function ServiceTestComparisonBreakdownPanel() {
    const paletteType = usePaletteType();
    const rawData = usePanelDataService(testComparisonDataSource);
    const chartData = useTestMetricBreakdownSeries(rawData, paletteType);
    const chartDef = useTestComparisonChartConfig(chartData, VARIANT_BREAKDOWN);

    return chartData ? <TestComparisonChart chartDef={chartDef} data={chartData} variant={VARIANT_BREAKDOWN} /> : null;
}

ServiceTestComparisonBreakdownPanel.propTypes = panelPropTypes;

ServiceTestComparisonBreakdownPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    contentHeight: 250,
    minContentHeight: 150,
};

export default Panel({
    typeAlias: 'TestComparisonBreakdownChart',
    catalogEntry: {
        category: PANEL_CATEGORIES.TEST,
        title,
        description: t`Before & after comparison of service test performance for a selected service test type, showing a breakdown of key metrics`,
        previewImage: COMPARISON_BREAKDOWN_PANEL_PREVIEW_IMAGE,
    },
    filters: {
        required: [timeRangeComparisonFilterId, testTypeFilterId],
        optional: [agentFilterId, businessServiceFilterId, siteFilterId],
    },
})(ServiceTestComparisonBreakdownPanel);
